var map = {
	"./amex-large.svg": "c55a",
	"./amex-stacked.png": "346c",
	"./amex-stacked.svg": "e2f7",
	"./amex.jpg": "766c",
	"./cal-diners-stacked.png": "4514",
	"./cal-diners-stacked.svg": "3c6a",
	"./cal-diners.png": "3621",
	"./cal-stacked.png": "be37",
	"./cal.jpg": "583b",
	"./discount-large.svg": "1d0a",
	"./discount-small.svg": "79f8",
	"./discount.jpg": "4511",
	"./doar-large.svg": "c5cd",
	"./doar.jpg": "e7ed",
	"./egud.jpg": "7b57",
	"./habeinleumi-large.svg": "ab7d",
	"./habeinleumi-small.svg": "7ac4",
	"./habenleumi.jpg": "c6b0",
	"./hapoalim-large.svg": "d4ce",
	"./hapoalim-small.svg": "a473",
	"./igud-large.svg": "6bec",
	"./igud-small.svg": "551e",
	"./isracard-large.svg": "fbec",
	"./isracard-stacked.svg": "d1f8",
	"./isracard.jpg": "c8d2d",
	"./jerusalem-large.jpg": "71d9",
	"./jerusalem.jpg": "8af7",
	"./leumi-large.svg": "bdb6",
	"./leumi-small.svg": "1031",
	"./leumi.jpg": "81cc",
	"./leumicard-max-stacked.png": "4048",
	"./leumicard-max.png": "356f",
	"./leumicard-stacked.png": "6693",
	"./leumicard.jpg": "aa7b",
	"./masad.jpg": "cc52",
	"./massad-large.svg": "d1d6",
	"./massad-small.svg": "2acf",
	"./max-leumi-stacked.svg": "b445",
	"./mercantil.jpg": "10b7",
	"./mercantile-large.png": "da94",
	"./mizrachi-large.svg": "9f7f1",
	"./mizrachi-small.svg": "ec1e",
	"./mizrahi.jpg": "7f17",
	"./otsar-large.jpg": "2649",
	"./otsar-large.png": "f708",
	"./otzarhahayal.jpg": "e326",
	"./pagi-large.png": "7c8f",
	"./pagi.jpg": "d13a",
	"./pepper-large.svg": "5a01",
	"./pepper.png": "1c10",
	"./poalim.jpg": "5817",
	"./ubank-large.png": "e612",
	"./ubank.jpg": "cd0a",
	"./yahav-large.jpg": "d504",
	"./yahav.jpg": "a85b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8136";